/**
 * @flow
 * @relayHash 999af8423b5ba992a0bce488b14bf2ee
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentMethod = "BANK_TRANSFER" | "CASH" | "CHECK" | "CREDIT_CARD" | "OTHER";
export type RecordPaymentInput = {|
  invoiceId: string,
  amount: number,
  paymentMethod?: ?PaymentMethod,
  referenceNumber?: ?string,
  paymentDate?: ?any,
  notes?: ?string,
|};
export type RecordPaymentMutationVariables = {|
  input: RecordPaymentInput
|};
export type RecordPaymentMutationResponse = {|
  +recordPayment: {|
    +payment: {|
      +id: string,
      +amount: number,
      +paymentMethod: PaymentMethod,
      +referenceNumber: ?string,
      +paymentDate: any,
      +notes: ?string,
      +createdAt: any,
    |}
  |}
|};
export type RecordPaymentMutation = {|
  variables: RecordPaymentMutationVariables,
  response: RecordPaymentMutationResponse,
|};
*/


/*
mutation RecordPaymentMutation(
  $input: RecordPaymentInput!
) {
  recordPayment(input: $input) {
    payment {
      id
      amount
      paymentMethod
      referenceNumber
      paymentDate
      notes
      createdAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RecordPaymentInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "recordPayment",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RecordPaymentPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "payment",
        "storageKey": null,
        "args": null,
        "concreteType": "Payment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "amount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "paymentMethod",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "referenceNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "paymentDate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RecordPaymentMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RecordPaymentMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "RecordPaymentMutation",
    "id": null,
    "text": "mutation RecordPaymentMutation(\n  $input: RecordPaymentInput!\n) {\n  recordPayment(input: $input) {\n    payment {\n      id\n      amount\n      paymentMethod\n      referenceNumber\n      paymentDate\n      notes\n      createdAt\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6ad15058f18029be5fcf0d68d976f144';
module.exports = node;
